import './config'

import Vue from 'vue'
import Router from 'vue-router'
import echarts from 'echarts'
import Storage from 'vue-ls'
import ElementUI from 'element-ui'
import {Message} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import App from './App.vue'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import router from './router/router'
import store from './store'
import Print from '@/utils/print'
import {staticUrl} from '@/config/env'
import '@/utils/enhance'
import 'nprogress/nprogress.css' // progress bar style
import '@/assets/css/element-variables.scss'
import '@/assets/css/global.less'
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/css/icommon-style.less'
import china from '@/assets/json/china.json'
// import VueEditor from "vue2-editor"
import htmlToPdf from '@/utils/htmlToPdf'
import Icon from 'vue2-svg-icon/Icon'
import config from '@/wincourse/defaultSettings'

const {publicPath} = require('../vue.config')
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location)
}
echarts.registerMap('china', china)

Vue.use(window.FormMaking)
Vue.use(Print) // 注册
// Vue.use(VueEditor)
Vue.use(htmlToPdf)
Vue.use(VueAxios, axios)
Vue.use(Storage, config.storageOptions)
Vue.use(ElementUI)
// Vue.use(echarts)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

Vue.component('icon', Icon)

Vue.filter('filterUrl', (val) => {
    if (!val) return ''

    if (val.startsWith("http://") || val.startsWith("https://")) {
        return val
    }

    if (val.indexOf('/assets/') === 0)
        // if (publicPath !== '/')
        return `${publicPath}${val.slice(1)}`

    if (val.indexOf('/img/') === 0)
        // if (publicPath !== '/')
        return `${publicPath}${val.slice(1)}`

    if (val.indexOf('/ultralab/') === 0) {
        return val.replace('/ultralab/', '/')
    }

    if (val.indexOf('/admin/') === 0)
        return val

    if (val.indexOf('/group1/') === 0)
        return `${staticUrl}/${val}`

    return `${staticUrl}/${val}`
})

router.beforeEach((to, from, next) => {
    NProgress.start()

    // 判断该路由是否需要登录权限
    if (from.path !== '/' && to.meta.requireAuth) {
        if (!store.getters.token) {
            Message({
                message: '请先登录',
                type: 'error'
            })
            next({path: from.path})
            NProgress.done()
            return
        }
    }

    next()
})

router.afterEach(() => {
    NProgress.done()
    window.scrollTo(0, 0)
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
